import {observer} from "mobx-react-lite";
import * as React from "react";
import {DnsData} from "../../models/ioc";

const DnsResults = observer(function DnsResults(props: { data?: DnsData }) {
    if (!props.data) {
        return <div>No data</div>
    }

    const {data} = props

    return <div className="dns-data">
        <h4>Command</h4>
        {data.command.map(v => <p>{v}</p>)}
        <h4>Question</h4>
        {data.question.map(v => <p>{v}</p>)}

        {data.answer.length > 0 && <div>
            <h4>Answer</h4>
            {data.answer.map(v => <p>{v}</p>)}
        </div>}

        {data.authority.length > 0 && <div>
            <h4>Authority</h4>
            {data.authority.map(v => <p>{v}</p>)}
        </div>}
    </div>
})

export default DnsResults